import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import Tooltip from '../Tooltip'

import { Heading2, Heading4, Paragraph } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Subheading = styled(Heading4)`
  margin-top: 48px;
  margin-bottom: 32px;
`

const RowWrapper = styled.div`
  margin-bottom: 72px;
`

const Row = styled.div`
  display: flex;
  column-gap: 16px;
  text-align: center;
  > * {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15%;
    min-height: 48px;
    padding: 8px 0px;
    border-bottom: 1px solid #dfe3f7;
    ${(p) => p.even && 'width: 20%;'}
  }
  > *:first-child {
    display: block;
    width: 40%;
    text-align: left;
    ${(p) => p.even && 'width: 20%;'}
  }
  strong {
    font-weight: 600;
  }
  a {
    font-weight: 600;
    text-decoration: underline;
  }
`

const ColumnHeading = styled.div`
  padding: 2px 8px;
  background-color: #300d4f;
  font-weight: 600;
  color: white;
  text-align: center;
`

const DetailedRow = styled.div`
  display: flex;
`

const DetailedRowHeading = styled.div`
  width: 50%;
  padding: 8px 16px;
  background-color: #300d4f;
  font-weight: 600;
  color: white;
`

const DetailedRowText = styled(Paragraph)`
  width: 50%;
  padding: 16px;
  background-color: #f9f8ff;
  ${(p) => p.dark && 'background-color: #eeecfb;'}
`

const Tables = () => {
  return (
    <>
      <Tooltip />
      <Heading>Tables</Heading>
      <Subheading>X and Y axis tables</Subheading>
      <RowWrapper>
        <Row>
          <div />
          <div>
            <ColumnHeading>Standard</ColumnHeading>
          </div>
          <div>
            <ColumnHeading>Premium</ColumnHeading>
          </div>
          <div>
            <ColumnHeading>Enterprise</ColumnHeading>
          </div>
          <div>
            <ColumnHeading>Priority</ColumnHeading>
          </div>
        </Row>
        <Row>
          <div>
            <strong>Heading</strong>
          </div>
          <div>
            <Link to="/">Call to action</Link>
          </div>
          <div>
            <Link to="/">Call to action</Link>
          </div>
          <div>Data</div>
          <div>Data</div>
        </Row>
        <Row>
          <div>
            <strong>Heading</strong>
            <br />
            Sub heading
          </div>
          <div>
            <img src="/images/no-icon.svg" alt="" />
          </div>
          <div>
            <img src="/images/no-icon.svg" alt="" />
          </div>
          <div>
            <img src="/images/yes-icon.svg" alt="" />
          </div>
          <div>
            <img src="/images/yes-icon.svg" alt="" />
          </div>
        </Row>
      </RowWrapper>
      <RowWrapper>
        <Row even>
          <div />
          <div>
            <strong>Heading</strong>
          </div>
          <div>
            <strong>Heading</strong>
          </div>
          <div>
            <strong>Heading</strong>
            <Tooltip content="Tooltip Text" place="top" />
          </div>
          <div>
            <strong>Heading</strong>
          </div>
        </Row>
        <Row even>
          <div>
            <ColumnHeading>Plus</ColumnHeading>
          </div>
          <div>Data</div>
          <div>Data</div>
          <div>
            <img src="/images/no.svg" alt="" />
          </div>
          <div>
            <Link to="/">Get in touch</Link>
          </div>
        </Row>
        <Row even>
          <div>
            <ColumnHeading>Plus</ColumnHeading>
          </div>
          <div>Data</div>
          <div>
            Data
            <Tooltip content="Tooltip Text" place="top" />
          </div>
          <div>
            <img src="/images/yes-icon.svg" alt="" />
          </div>
          <div>
            <Link to="/">Get in touch</Link>
          </div>
        </Row>
      </RowWrapper>

      <Subheading>Detailed content table</Subheading>
      <DetailedRow>
        <DetailedRowHeading>Heading</DetailedRowHeading>
        <DetailedRowHeading>Heading</DetailedRowHeading>
      </DetailedRow>
      <DetailedRow>
        <DetailedRowText>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.
        </DetailedRowText>
        <DetailedRowText>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.
        </DetailedRowText>
      </DetailedRow>
      <DetailedRow>
        <DetailedRowText dark>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.
        </DetailedRowText>
        <DetailedRowText dark>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.
        </DetailedRowText>
      </DetailedRow>
    </>
  )
}

export default Tables
